import { FrequencyType } from 'constants/loanApplication';
import { frequencyOptions } from 'constants/options';

export const ANNUAL_FREQUENCY_OPTION = frequencyOptions.find(
  ({ value }) => value === FrequencyType.ANNUAL,
);

export const MonthsCollectedChangeKind = {
  MANUAL: 'ManualMonthsCollected',
  CALCULATED: 'CalculatedMonthsCollected',
};
